'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgBookmarkFill } from '@common/icon';
import { cn } from '@core/utils';
import { BOOKMARK_TYPE } from '@/api';
import { useBookmark } from '@/hooks/useBookmark';
interface BookmarkButtonProps {
  policyId: number;
  policyName: string;
  agency: string;
  isBookmarked: boolean;
  bookmarkCount: number;
}
export const BookmarkButton = t0 => {
  const $ = _c(17);
  const {
    policyId,
    policyName,
    agency,
    isBookmarked,
    bookmarkCount
  } = t0;
  const {
    bookmark
  } = useBookmark();
  let t1;
  if ($[0] !== agency || $[1] !== bookmark || $[2] !== isBookmarked || $[3] !== policyId || $[4] !== policyName) {
    t1 = e => {
      e.preventDefault();
      e.stopPropagation();
      bookmark({
        contentId: policyId,
        isBookmarked,
        bookmarkType: BOOKMARK_TYPE.POLICY,
        contentName: policyName,
        policyAgency: agency
      });
    };
    $[0] = agency;
    $[1] = bookmark;
    $[2] = isBookmarked;
    $[3] = policyId;
    $[4] = policyName;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleBookmarkClick = t1;
  const t2 = `${policyName} 스크랩 ${isBookmarked ? "\uCDE8\uC18C" : "\uD558\uAE30"}`;
  const t3 = isBookmarked ? "text-B-500" : "text-Gray-300";
  let t4;
  if ($[6] !== t3) {
    t4 = cn("size-20 transition-all duration-200 ease-out group-hover:scale-110 group-active:scale-100", t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <SvgBookmarkFill className={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== bookmarkCount) {
    t6 = <p className="text-Gray-500 transition-colors typo-caption1 group-hover:text-Gray-700" aria-hidden="true">{bookmarkCount}</p>;
    $[10] = bookmarkCount;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== handleBookmarkClick || $[13] !== t2 || $[14] !== t5 || $[15] !== t6) {
    t7 = <Button theme="sub-text" className="group -m-12 flex h-fit min-h-44 min-w-44 flex-col items-center justify-center gap-0 p-12" onClick={handleBookmarkClick} aria-label={t2}>{t5}{t6}</Button>;
    $[12] = handleBookmarkClick;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};